import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import './TS_MultiSelect.scss';
import { LL_H_C, LL_V_L } from '../Layouts/index.js';
import { _className } from '../../utils/tools.js';
import { TS_ListOrganizer } from '../TS_ListOrganizer/TS_ListOrganizer.js';
export class TS_MultiSelect_V2 extends Component {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static prepare(_props) {
        return (props) => _jsx(TS_MultiSelect_V2, { ..._props, ...props });
    }
    render() {
        const editable = this.props.editable;
        const prop = this.props.prop;
        const editableProp = editable.editProp(prop, []);
        const existingItems = editableProp.item;
        let itemsToRender = this.props.selectionFilter ? existingItems.filter(this.props.selectionFilter) : existingItems;
        if (this.props.sort)
            itemsToRender = this.props.sort(itemsToRender);
        const addInnerItem = async (item) => {
            await editableProp.updateArrayAt(item);
            this.forceUpdate();
        };
        const props = this.props;
        const SelectionRenderer = props.selectionRenderer;
        const direction = this.props.itemsDirection ?? 'horizontal';
        const Wrapper = direction === 'horizontal' ? LL_H_C : LL_V_L;
        const className = _className('ts-multi-select__list', this.props.disabled && 'disabled', this.props.className);
        return _jsxs(Wrapper, { className: className, children: [itemsToRender.map((item, i) => {
                    const key = props.getItemKey?.(item, i) ?? i;
                    return _jsx(LL_H_C, { className: "ts-multi-select__list-value", children: props.itemRenderer(item, async () => {
                            const index = existingItems.indexOf(item);
                            if (index < 0)
                                return;
                            await editableProp.removeArrayItem(index);
                            this.forceUpdate();
                        }, this.props.disabled ?? false, i, editableProp) }, key);
                }), !this.props.disabled && SelectionRenderer({
                    className: 'ts-multi-select__selector',
                    onSelected: addInnerItem,
                    existingItems: existingItems,
                    queryFilter: this.props.itemFilter
                })] });
    }
}
export class TS_MultiSelect_Sortable extends Component {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static prepare(_props) {
        return (props) => _jsx(TS_MultiSelect_Sortable, { ..._props, ...props });
    }
    render_Item = (editable, props) => {
        const className = _className('multi-select__item-wrapper', props.dragged && 'dragged');
        const key = this.props.getItemKey?.(props.item, props.index) ?? props.index;
        return _jsx(LL_H_C, { className: className, draggable: !this.props.disabled, onDragStart: e => {
                if (this.props.disabled)
                    return;
                const container = e.currentTarget;
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/html', container);
                e.dataTransfer.setDragImage(container, 150, 30);
                props.onDragStart(e, props.index);
            }, onDragEnd: props.onDragEnd, onDragOver: e => props.onDragOver(e, props.index), onDragLeave: e => props.onDragLeave(e, props.index), children: this.props.itemRenderer(props.item, async () => {
                await editable.removeArrayItem(props.index);
                this.forceUpdate();
            }, this.props.disabled ?? false, props.index, editable) }, key);
    };
    render() {
        const editable = this.props.editable.editProp(this.props.prop, []);
        const className = _className('ts-multi-select__sortable', this.props.disabled && 'disabled', this.props.className);
        const itemsToRender = this.props.selectionFilter ? editable.item.filter(this.props.selectionFilter) : editable.item;
        const SelectionRenderer = this.props.selectionRenderer;
        return _jsxs(LL_V_L, { className: className, children: [_jsx(TS_ListOrganizer, { items: itemsToRender, renderer: (item) => this.render_Item(editable, item), onOrderChanged: async (items) => {
                        // @ts-ignore
                        await this.props.editable.updateObj({ [this.props.prop]: items });
                        this.forceUpdate();
                    } }), !this.props.disabled && SelectionRenderer({
                    className: 'ts-multi-select__selector',
                    existingItems: editable.item,
                    queryFilter: this.props.itemFilter,
                    onSelected: async (item) => {
                        await editable.updateArrayAt(item);
                        this.forceUpdate();
                    },
                })] });
    }
}
//# sourceMappingURL=TS_MultiSelect_V2.js.map